/**
 * Stable CSS class names for E2E / automation — Cargo Management V2.
 */
export const CMV = {
    page: 'cargo-management-v2-page',
    layout: 'cargo-management-v2-page__layout',
    breadcrumbRow: 'cargo-management-v2-page__breadcrumb-row',
    toolbar: 'cargo-management-v2-page__toolbar',
    datagridSection: 'cargo-management-v2-page__datagrid-section',
    excelDownloadWrap: 'cargo-management-v2-page__excel-download',
    datagrid: 'cargo-management-v2-page__datagrid',
    filterPanel: 'cargo-management-v2-page__filter-panel',

    input: 'cargo-management-v2-input',
    inputButton: 'cargo-management-v2-input--button',
    inputSelect: 'cargo-management-v2-input--select',
    inputTextfield: 'cargo-management-v2-input--textfield',
    inputIconButton: 'cargo-management-v2-input--icon-button',
    inputMenuItem: 'cargo-management-v2-input--menu-item',

    btnAddNew: 'cargo-management-v2-field--add-new',
    btnFilter: 'cargo-management-v2-field--filter',
    fieldFilterCompany: 'cargo-management-v2-field--filter-cargo-company',

    rowActionsTrigger: 'cargo-management-v2-field--row-actions-trigger',
    rowActionEdit: 'cargo-management-v2-field--row-action-edit',
    rowActionDelete: 'cargo-management-v2-field--row-action-delete',

    drawer: 'cargo-management-v2-drawer',
    drawerBody: 'cargo-management-v2-drawer__body',
    drawerForm: 'cargo-management-v2-drawer__form',
    drawerActions: 'cargo-management-v2-drawer__actions',

    fieldDrawerCompany: 'cargo-management-v2-field--drawer-cargo-company',
    fieldDrawerCity: 'cargo-management-v2-field--drawer-city',
    fieldDrawerCounty: 'cargo-management-v2-field--drawer-county',
    fieldDrawerOrderLimit: 'cargo-management-v2-field--drawer-order-limit',
    btnDrawerSubmit: 'cargo-management-v2-field--drawer-submit',
} as const;

export const cmvCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
